import React from 'react';

import styles from './tablet-max-input.module.scss';
import { InnerInputProps } from '../types';
import { InputBase } from '../input-base';

const TabletMaxInput: React.FC<InnerInputProps> = (props) => {
  return <InputBase styles={styles} {...props} />;
};

export { TabletMaxInput };
